import { apiService } from './api';

export interface MonthlyCostData {
  previousMonth: {
    period: string;
    actualSpend: number;
    byService: { [key: string]: number };
  };
  currentMonth: {
    period: string;
    actualSpend: number;
    projectedSpend: number;
    byService: { [key: string]: number };
  };
  percentageChange: number;
}

class BillingService {
  async getMonthlyCosts(): Promise<MonthlyCostData> {
    try {
      const { data } = await apiService.get('/billing/monthly-costs');
      return data.data;
    } catch (error: any) {
      console.error('Failed to fetch monthly costs:', error);
      throw error;
    }
  }
}

export const billingService = new BillingService();